
import cloneDeep from 'lodash/cloneDeep';
import union from 'lodash/union';

import {
    SET_MESSAGE,
    SET_OBJECT,
    SET_OBJECT_CREATE,
    SET_OBJECT_CREATE_ATTR_VALUE,
    SET_OBJECT_EDIT,
    SET_OBJECT_EDIT_ATTR_VALUE,
    SET_OBJECT_LIST,
    SET_TYPE,
    UPDATE_OBJECT_EDIT
} from '../sagas/info';

import {
    INFO_TYPE_HOME,
    INFO_TYPE_NO,
    INFO_TYPE_OBJECT,
    INFO_TYPE_OBJECT_CREATE,
    INFO_TYPE_OBJECT_EDIT,
    INFO_TYPE_OBJECT_LIST
} from './infoPanelType';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.data.reducer.info');

const initialState = {
    coordinates: null,
    message: '',
    objectKey: null,
    objectCache: {},
    objectCreate: null,
    objectCreateKey: null,
    objectCreateChanged: [],
    objectEdit: null,
    objectEditKey: null,
    objectEditChanged: [],
    objectKeyList: null,
    sourceType: null,
    type: INFO_TYPE_HOME
};

export function calculateObjectKey(object) {
    return (object)
        ? `${object.layerId}_${object.attributes.gid}`
        : `NULL_OBJECT`;
}

function calculateCache(objectList) {
    return objectList.reduce((previous, current) => {
        previous[calculateObjectKey(current)] = current;
        return previous;
    }, {});
}

export function getCoordinates(state) {
    return state.coordinates;
}

export function getMessage(state) {
    return state.message;
}

export function getObject(state) {
    return state.objectCache[state.objectKey];
}

export function getObjectCreate(state) {
    return state.objectCreate;
}

export function getObjectCreateKey(state) {
    return state.objectCreateKey;
}

export function getObjectCreateChanged(state) {
    return state.objectCreateChanged;
}

export function getObjectEdit(state) {
    return state.objectEdit;
}

export function getObjectEditKey(state) {
    return state.objectEditKey;
}

export function getObjectEditChanged(state) {
    return state.objectEditChanged;
}

export function getObjectList(state) {
    return state.objectKeyList.map(item => {
        return state.objectCache[item];
    });
}

export function getSourceType(state) {
    return state.sourceType;
}

export function getType(state) {
    return state.type || INFO_TYPE_HOME;
}

function mergeObjectToCache(cache, object) {
    const key = calculateObjectKey(object);
    if (cache[key]) {
        return cache;
    } else {
        return {
            ...cache,
            [key]: object
        };
    }
}

function setMessage(state, action) {
    return {
        ...state,
        message: action.message
    };
}

function setObject(state, action) {
    return {
        ...state,
        coordinates: action.coordinates,
        objectKey: calculateObjectKey(action.object),
        objectCache: mergeObjectToCache(state.objectCache, action.object),
        sourceType: action.sourceType,
        type: INFO_TYPE_OBJECT
    };
}

function setObjectCreate(state, action) {
    return {
        ...state,
        coordinates: null,
        objectCreate: {
            attributes: {},
            dataModelId: action.dataModelItem.id
        },
        objectCreateKey: action.dataModelItem.id,
        objectCreateChanged: [],
        type: INFO_TYPE_OBJECT_CREATE
    };
}

function setObjectCreateAttrValue(state, action) {
    return {
        ...state,
        objectCreateChanged: union(
            state.objectCreateChanged,
            [action.attrName]
        ),
        objectCreate: {
            ...state.objectCreate,
            attributes: {
                ...state.objectCreate.attributes,
                [action.attrName]: action.value
            }
        }
    };
}

function setObjectEdit(state, action) {
    return {
        ...state,
        coordinates: null,
        objectEdit: cloneDeep(action.object),
        objectEditKey: calculateObjectKey(action.object),
        objectEditChanged: [],
        type: INFO_TYPE_OBJECT_EDIT
    };
}

function setObjectEditAttrValue(state, action) {
    return {
        ...state,
        objectEditChanged: union(
            state.objectEditChanged,
            [action.attrName]
        ),
        objectEdit: {
            ...state.objectEdit,
            attributes: {
                ...state.objectEdit.attributes,
                [action.attrName]: action.value
            }
        }
    };
}

function setObjectList(state, action) {
    return {
        ...state,
        coordinates: action.coordinates,
        objectCache: calculateCache(action.objectList),
        objectKeyList: action.objectList.map(item => {
            return calculateObjectKey(item);
        }),
        type: ((action.objectList.length === 0) && (action.finished))
            ? INFO_TYPE_NO
            : INFO_TYPE_OBJECT_LIST
    };
}

function setType(state, action) {
    return {
        ...state,
        type: action.panelType
    };
}

function updateObjectEdit(state, action) {
    let object = cloneDeep(getObject(state));

    Object.keys(action.object).forEach(item => {
        object.attributes[item] = action.object[item];
    });

    return {
        ...state,
        objectCache: {
            ...state.objectCache,
            [state.objectKey]: object
        }
    };
}

function info(state = initialState, action) {
    switch (action.type) {

        case SET_MESSAGE:
            return setMessage(state, action);

        case SET_OBJECT:
            return setObject(state, action);

        case SET_OBJECT_CREATE:
            return setObjectCreate(state, action);

        case SET_OBJECT_CREATE_ATTR_VALUE:
            return setObjectCreateAttrValue(state, action);

        case SET_OBJECT_EDIT:
            return setObjectEdit(state, action);

        case SET_OBJECT_EDIT_ATTR_VALUE:
            return setObjectEditAttrValue(state, action);

        case SET_OBJECT_LIST:
            return setObjectList(state, action);

        case SET_TYPE:
            return setType(state, action);

        case UPDATE_OBJECT_EDIT:
            return updateObjectEdit(state, action);

        default:
            return state;
    }
}

export default info;
